import "maplibre-gl/dist/maplibre-gl.css";
import "./style.css";
import { RadarApp } from "./app";

new RadarApp();
